<mat-paginator
  class="borderless no-background"
  [length]="entitiesLength"
  [pageSize]="pageSize">
</mat-paginator>
